import React from "react";
import { Link } from "react-router-dom";
import Nav from "../componets/nav";
import "./aboutpage.css";

const AboutPage = () => (
  <div className="about-page">
    <Nav />
    <div className="about-container">
      <header className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-title">About Steelblade Photography</h1>
          <p className="about-subtitle">
            Capturing the raw power and beauty of automotive excellence
          </p>
        </div>
      </header>

      <section className="about-content">
        <div className="about-section">
          <h2>Our Story</h2>
          <p>
            Born from a passion for speed and visual storytelling, Steelblade
            Photography specializes in high-octane automotive photography. We
            don't just take pictures – we freeze moments of pure adrenaline,
            capturing the soul of every machine and the thrill of every race.
          </p>
        </div>

        <div className="about-section">
          <h2>What We Do</h2>
          <div className="services-grid">
            <Link
              to="/gallery?tab=trackPhotography"
              className="service-item service-link"
            >
              <h3>Track Photography</h3>
              <p>
                Dynamic action shots during races, track days, and automotive
                events.
              </p>
            </Link>
            <Link
              to="/gallery?tab=carShowExhibitions"
              className="service-item service-link"
            >
              <h3>Car Shows & Exhibitions</h3>
              <p>
                Professional automotive portraiture showcasing every detail and
                curve.
              </p>
            </Link>
            <Link
              to="/gallery?tab=customShoots"
              className="service-item service-link"
            >
              <h3>Custom Shoots</h3>
              <p>
                Personalized photography sessions for car enthusiasts and
                collectors.
              </p>
            </Link>
            <Link
              to="/gallery?tab=commercialWork"
              className="service-item service-link"
            >
              <h3>Commercial Work</h3>
              <p>
                Brand campaigns, dealership photography, and automotive
                marketing.
              </p>
            </Link>
          </div>
        </div>

        <div className="about-section">
          <h2>Our Approach</h2>
          <p>
            Every shot tells a story. Whether it's the focused determination of
            a driver mid-corner, the gleaming perfection of a show car, or the
            raw power captured in motion blur, we approach each project with
            technical precision and creative vision.
          </p>
          <p>
            Using cutting-edge equipment, we deliver images that don't just
            document – they inspire.
          </p>
        </div>

        <div className="about-section">
          <h2>Why Choose Steelblade?</h2>
          <ul className="about-list">
            <li>
              Specialized expertise in automotive and motorsport photography
            </li>
            <li>Professional-grade equipment designed for high-speed action</li>
            <li>Deep understanding of automotive culture and aesthetics</li>
            <li>Quick turnaround times for event and commercial work</li>
            <li>Collaborative approach to bring your vision to life</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="team-photo">
                <img
                  src={require("../componets/img/team/photographer1.jpg")}
                  alt="Lead Photographer"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="photo-placeholder" style={{ display: "none" }}>
                  <span>Photo Coming Soon</span>
                </div>
              </div>
              <div className="team-info">
                <h3>Phillip van der Hoven</h3>
                <p className="team-title">Co-Founder, Senior Photographer</p>
                <p className="team-bio">
                  With a passion for storytelling through imagery, Phillip van
                  der Hoven has spent the past few years developing a distinct
                  style across both conceptual and commercial photography. His
                  work blends technical precision with artistic vision, making
                  him a versatile and reliable creative. Whether capturing the
                  elegance of a landscape or the grit of automotive culture,
                  Phillip brings a thoughtful and refined approach to every
                  project.
                </p>
                <div className="team-specialties">
                  <span>Videographer</span>
                  <span>Action Sports</span>
                  <span>Commercial Work</span>
                </div>
              </div>
            </div>

            <div className="team-member">
              <div className="team-photo">
                <img
                  src={require("../componets/img/team/photographer2.jpg")}
                  alt="Senior Photographer"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="photo-placeholder" style={{ display: "none" }}>
                  <span>Photo Coming Soon</span>
                </div>
              </div>
              <div className="team-info">
                <h3>Sean Spijkers</h3>
                <p className="team-title">Co-Founder, Senior Photographer</p>
                <p className="team-bio">
                  With a passion for capturing the essence of automotive
                  culture, Sean has spent over 5 years honing his skills in
                  various photography styles. His attention to detail and
                  ability to connect with clients make him a valuable asset to
                  the SteelBlade team.
                </p>
                <div className="team-specialties">
                  <span>Car Shows</span>
                  <span>Custom Shoots</span>
                  <span>Detail Photography</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default AboutPage;
